'use strict';

import state from './state';
import mutations from './mutations';
import actions from './action';
import getters from './getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/so/index.js